
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/electric-cars/page/[page]",
      function () {
        return require("private-next-pages/guides/electric-cars/page/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/electric-cars/page/[page]"])
      });
    }
  